import React, { useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { ModalCore } from "src/Pages/components";
import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";

import { UseFormCancelContratos } from "../hooks/UseFeatFormCancelContratos";

import { FormStatusContrato } from "./FormCancelContrato";
import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { CardBodyCore } from "src/Pages/components/CardCore/Components/CardBodyCore";

const STATUS_LEGEND: { label: string; description: string }[] = [
  {
    label: "Aprovado",
    description: "Contrato aprovado; todas as parcelas continuam normalmente.",
  },
  {
    label: "Pendente",
    description: "Contrato em análise, ainda sem decisão final.",
  },
  {
    label: "Validação",
    description: "Contrato aguardando validação para avançar.",
  },
  {
    label: "Cancelado - A",
    description: "Contrato cancelado, mas mantém as parcelas já abertas.",
  },
  {
    label: "Cancelado - X",
    description:
      "Contrato cancelado e todas as parcelas em aberto são excluídas.",
  },
  {
    label: "Não efetivado",
    description:
      "Contrato não foi efetivado e as parcelas também são excluídas.",
  },
];

interface IModalUpdateStatusContrato {
  openModalStatus: boolean;
  setOpenModalStatus: React.Dispatch<React.SetStateAction<boolean>>;
}

export const statusContract = {
  APPROVED: "Aprovado",
  CANCELLED: "Cancelado - A",
  PENDING: "Pendente",
  VALIDATION: "Validação",
  NAO_EFETIVADO: "Não efetivado",
  CANCELAR_DELETAR_PARCELAS: "Cancelado - X",
};

export const ModalUpdateStatusContrato = ({
  openModalStatus,
  setOpenModalStatus,
}: IModalUpdateStatusContrato) => {
  const { setId } = useConfigPageContext();

  const { setValuesInputCancelarContrato } = useContextContrato();

  useEffect(() => {
    if (!openModalStatus) {
      setValuesInputCancelarContrato({
        description: "",
        date: `${GetDateUSSemValue()}`,
        status: "APPROVED",
      });
      setId("");
    }
  }, [openModalStatus]);

  const { handleUpdateStatusContratos, loading: loadingCancelModal } =
    UseFormCancelContratos({
      setOpenModalCancel: setOpenModalStatus,
    });

  return (
    <ModalCore
      loadingSubmit={loadingCancelModal}
      open={openModalStatus}
      setOpen={setOpenModalStatus}
      sxStyle={{ width: 600 }}
      title="Alterar status do Contrato"
      onChange={handleUpdateStatusContratos}
    >
      <FormStatusContrato />

      <CardCore sxStyle={{ m: "0" }}>
        <Typography sx={{ fontSize: "1rem", fontWeight: 600, color: "text.secondary", mb: "12px" }}> Status do Contrato</Typography>
        <Stack spacing={0.5} sx={{ pt: 0.25 }}>
          {STATUS_LEGEND.map(({ label, description }) => (
            <Typography
              key={label}
              variant="caption"
              component="div"
              sx={{
                m: 0,
                lineHeight: 1.4,
                color: "text.secondary",
                fontSize: "0.85rem",
              }}
            >
              <Box component="span" sx={{ fontWeight: 600, color: "text.primary" }}>
                {label}:
              </Box>{" "}
              {description}
            </Typography>
          ))}
        </Stack>
      </CardCore>
    </ModalCore>
  );
};
